import { init, CoreParams } from './init';
import { markPerformance } from './performance/index';
import { ErrorReporter } from './errorReporter.type';

markPerformance('core-start');

export const initCore = (params: CoreParams, errorReporter: ErrorReporter) => init(params, errorReporter);

export * from './ads/ads.types';
export * from './init';
